export default __webpack_public_path__ + "static/genuine-care-7fbf24d3a502783edb4d5684afc725dd.svg";